import TheHeader from './views/static_elements/TheHeader.vue';
import TheFooter from './views/static_elements/TheFooter.vue';

import Home from './views/Home.vue'
import Login from './views/Login.vue';
import CreateUser from './views/CreateUser.vue';
import AdminSystem from './views/AdminSystem.vue';
import AdminStats from './views/AdminStats.vue';



import PrtokolErfassen from './views/protokol_action/ProtokolErfassen.vue'
import ProtokolAnschauen from './views/protokol_action/ProtokolAnschauen.vue'
import ProtokolList from './views/protokol_action/ProtokolList.vue'
import { isMobileBuild } from './utils/platform';


const adminRoutes = [
    {
        path: '/create_user',
        redirect: '/portal/create_user'
    },
    {
        path: '/admin_system',
        redirect: '/portal/admin_system'
    },
    {
        path: '/admin_stats',
        redirect: '/portal/admin_stats'
    },
    {
        path: '/portal/create_user',
        name: 'new_user',
        components: {
            header: TheHeader,
            main: CreateUser,
            footer: TheFooter
        }
    },
    {
        path: '/portal/admin_system',
        name: 'admin_system',
        components: {
            header: TheHeader,
            main: AdminSystem,
            footer: TheFooter
        }
    },
    {
        path: '/portal/admin_stats',
        name: 'admin_stats',
        components: {
            header: TheHeader,
            main: AdminStats,
            footer: TheFooter
        }
    },
];

export default [
    {
        path: '/',
        redirect: () =>
            isMobileBuild() ? { name: 'protokolerfassen' } : '/portal/login',
    },
    {
        path: '/home',
        redirect: '/portal/home'
    },
    {
        path: '/login',
        redirect: '/portal/login'
    },
    {
        path: '/protokol_erfassen',
        redirect: '/portal/protokol_erfassen'
    },
    {
        path: '/protokol_list',
        redirect: '/portal/protokol_list'
    },
    {
        path: '/protokol_anschauen',
        redirect: '/portal/protokol_anschauen'
    },
    {
        path: '/portal/home',
        name: 'home',
        components: {
            header: TheHeader,
            main: Home,
            footer: TheFooter,
        }
    },
    {
        path: '/portal/login',
        components: {
            main: Login,
        }
    },
    ...(isMobileBuild() ? [] : adminRoutes),
    {
        name: 'protokolerfassen',
        path: '/portal/protokol_erfassen',
        components: {
            header: TheHeader,
            main: PrtokolErfassen,
            footer: TheFooter,
        }
    },
    {
        name: 'displayProtokol',
        path: '/portal/protokol_list/:itemId/:status',
        components: {
            header: TheHeader,
            main: ProtokolAnschauen,
            footer: TheFooter
        },
        props: true,
    },
    {
        name: 'prtokollist',
        path: '/portal/protokol_list/:listType',
        components: {
            header: TheHeader,
            main: ProtokolList,
            footer: TheFooter
        },
        props: true,
        meta: { keepOnQueryChange: true },
    },



    {
        name: 'protokolanschauen',
        path: '/portal/protokol_anschauen',
        components: {
            header: TheHeader,
            main: ProtokolAnschauen,
            footer: TheFooter,
        }
    },
    { path: '/:notFound(.*)', redirect: '/home' },

]
